import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { InformationPopupStore, UserPageSettings } from '@store';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';

import { InformationPageConfig, InformationPopupPage } from './information-popup.model';

@Component({
  selector: 'app-information-popup',
  templateUrl: './information-popup.component.html',
  styleUrls: ['./information-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationPopupComponent implements OnInit, OnDestroy {
  @Input() page: InformationPopupPage;

  expanded = false;
  activePageConfig: InformationPageConfig;

  pagesConfig: InformationPageConfig[] = [
    {
      page: InformationPopupPage.BackupAndRestore,
      titleKey: '+INFORMATION_POPUP.BACKUP_AND_RESTORE_TITLE',
      descriptionKey: '+INFORMATION_POPUP.BACKUP_AND_RESTORE_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.ExtendedParameters,
      titleKey: '+INFORMATION_POPUP.EXTENDED_PARAMETERS_TITLE',
      descriptionKey: '+INFORMATION_POPUP.EXTENDED_PARAMETERS_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.GuidedTroubleshooting,
      titleKey: '+INFORMATION_POPUP.GUIDED_TROUBLESHOOTING_TITLE',
      descriptionKey: '+INFORMATION_POPUP.GUIDED_TROUBLESHOOTING_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.HydraulicSchemes,
      titleKey: '+INFORMATION_POPUP.HYDRAULIC_SCHEMES_TITLE',
      descriptionKey: '+INFORMATION_POPUP.HYDRAULIC_SCHEMES_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.Snapshot,
      titleKey: '+INFORMATION_POPUP.SNAPSHOT_TITLE',
      descriptionKey: '+INFORMATION_POPUP.SNAPSHOT_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.RemoteServiceAnomalies,
      titleKey: '+REMOTE_SERVICE.TABS_ANOMALIES',
      descriptionKey: '+INFORMATION_POPUP.REMOTE_SERVICE_ANOMALIES_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.RemoteServiceDiagnosis,
      titleKey: '+REMOTE_SERVICE.TABS_DIAGNOSIS',
      descriptionKey: '+INFORMATION_POPUP.REMOTE_SERVICE_DIAGNOSIS_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.RemoteServiceFeatures,
      titleKey: '+REMOTE_SERVICE.TABS_FEATURES',
      descriptionKey: '+INFORMATION_POPUP.REMOTE_SERVICE_FEATURES_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
    {
      page: InformationPopupPage.RemoteServiceReport,
      titleKey: '+REMOTE_SERVICE.TABS_REPORT',
      descriptionKey: '+INFORMATION_POPUP.REMOTE_SERVICE_REPORT_DESCRIPTION',
      imageUrl: '/assets/img/diagnostic_installer_guy.svg',
    },
  ];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(public informationPopupStore: InformationPopupStore) {}

  ngOnInit(): void {
    this.activePageConfig = this.pagesConfig.find((entry) => entry.page === this.page);

    this.informationPopupStore
      .getUserPageSettings(this.page)
      .pipe(
        filter((entry) => !!entry),
        take(1),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((settings: UserPageSettings) => {
        this.expanded = settings.showExpanded;
      });
  }

  openPopup(): void {
    this.expanded = true;
  }

  closePopup(): void {
    this.expanded = false;
    this.informationPopupStore.setPageSettings(this.page);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
